<script>
    import FundsFilter from "./search/FundsFilter.svelte";
    import SearchBar from "./search/SearchBar.svelte";
    import SearchTerms from "./search/SearchTerms.svelte";
    import FacetsContainer from "./search/FacetsContainer.svelte";
    import YearsFilter from "./search/YearsFilter.svelte";
    import OPTS from '../libs/options';
    import API from "../libs/api";
    import { query, searchTags } from "../libs/stores";
    import { newFundFilter } from "../libs/typefactories";

    const yearsMinMax = API.yearsMinMax({filters: OPTS.global_filters});
    let selectedFund = OPTS.selected_fund;

    function addSearchFilterHandler(event) {
        query.add(event.detail);
    }

    function removeSearchFilterHandler(event) {
        query.remove(event.detail)
    }

    function sortHandler(event) {
        query.sort(event.detail.field, event.detail.order)
    }

    $: addSearchFilterHandler({detail: newFundFilter(selectedFund)});
</script>

<div class="o-block-container">
    <div class="o-container--inner">
        <div class="c-search" class:c-search--minimal={OPTS.minimal}>
            {#if OPTS.title}
                <h3>Documenti della raccolta</h3>
            {/if}

            <form class="c-search__form" on:submit={(e) => e.preventDefault()}>
                {#if !OPTS.disable.funds}
                    <FundsFilter fondi={OPTS.funds} bind:selected={selectedFund} />
                    <div class="c-search__separator-line"></div>
                {/if}

                {#if !OPTS.disable.search}
                    <SearchBar on:search={addSearchFilterHandler} />
                {/if}

                {#if !OPTS.disable.search && $searchTags.length}
                    <SearchTerms tags={$searchTags} on:removeTag={removeSearchFilterHandler} />
                {/if}

                {#if !OPTS.disable.search}
                <div class="c-advanced-filters c-advanced-filters--mobile">
                    <button class="c-advanced-filters__panel-button c-advanced-filters__panel-button--open"><span>Ricerca avanzata</span>
                    </button>
                </div>
                {/if}

                {#if !OPTS.disable.year_filter}
                    {#await yearsMinMax then {min, max}}
                        <YearsFilter {min} {max} on:change={addSearchFilterHandler} />
                    {/await}
                {/if}

                <FacetsContainer on:sort={sortHandler} />
            </form>
        </div>
    </div>
</div>
